import { useMemo } from "react";

import { Table } from "@mantine/core";

import { TextWrapper } from "@/components/TextWrapper";
import { usDateFormat } from "@/utils/datetime";

interface DateRowProps {
  date: string | undefined;
}

export default function DateRow({ date }: DateRowProps) {
  const formattedDate = useMemo(() => usDateFormat(date), [date]);

  if (!formattedDate) {
    return null;
  }

  return (
    <Table.Tr>
      <Table.Td
        ta="center"
        bg="gray.0"
        colSpan={12}
        style={{
          borderBottom: "4px solid var(--mantine-color-cream-4)",
        }}
      >
        <TextWrapper fz="md" c="gray.7" variant="bold">
          {formattedDate}
        </TextWrapper>
      </Table.Td>
    </Table.Tr>
  );
}
